import * as yup from "yup";
import moment from "moment-timezone";



const validateOnCoach = (ownFieldValue, context, validationMsg) => {
  const { createError, path, parent } = context
  const candidate_portal_role = parent.candidate_portal_role

  if (!ownFieldValue && (candidate_portal_role?.selectOptionLabel === "Coach" || candidate_portal_role?.selectOptionLabel === "Coach Admin")) {

    return createError({
      path,
      message: validationMsg,
    })
  } else {
    return true
  }
}

export const createAdminUserValidation = (adminUserValidationCMSDataLabel) => {
  const fetchAdminUserValidationLabel = (key) => {
    return adminUserValidationCMSDataLabel?.find((el) => el.Key === key)?.Phrase || '';
  }

  const roleErrorMsg = fetchAdminUserValidationLabel('AdminUserValidationMsg.RoleMandatory');

  const schema = yup.object().shape({
    first_name: yup.string().label('This field').required(fetchAdminUserValidationLabel('AdminUserValidationMsg.FieldRequired')).max(200),
    last_name: yup.string().label('This field').required(fetchAdminUserValidationLabel('AdminUserValidationMsg.FieldRequired')).max(200),
    preferred_name: yup.string().label('This field').optional().max(200),
    email: yup.string().label('This field').required(fetchAdminUserValidationLabel('AdminUserValidationMsg.FieldRequired')).max(200),
    affiliate_email: yup.string().label('This field').optional().max(200),
    preferred_number: yup.string().label('This field').optional().max(200),
    time_zone: yup.object().label('This field').required().typeError(fetchAdminUserValidationLabel('AdminUserValidationMsg.FieldRequired')),
    country_user_details: yup.object().label('This field').required().typeError(fetchAdminUserValidationLabel('AdminUserValidationMsg.FieldRequired')),
    application_language: yup.object().label('This field').required().typeError(fetchAdminUserValidationLabel('AdminUserValidationMsg.FieldRequired')),
    service_office_user_details: yup.object().label('This field').required().typeError(fetchAdminUserValidationLabel('AdminUserValidationMsg.FieldRequired')),
    status: yup.object().label('This field').required().typeError(fetchAdminUserValidationLabel('AdminUserValidationMsg.FieldRequired')),

    enterprise_admin_check: yup.boolean()
      .test('enterprise_admin_role_required', (ownFieldValue, { createError, path, parent }) => {
        const client_portal_role = parent.client_portal_role
        const candidate_portal_role = parent.candidate_portal_role

        if (!!ownFieldValue || !!client_portal_role?.id || !!candidate_portal_role?.id) {
          return true
        } else {
          return createError({
            path,
            message: roleErrorMsg,
          })
        }
      }),
    candidate_portal_role: yup.object()
      .test('candidate_portal_role_required', (ownFieldValue, { createError, path, parent }) => {
        const client_portal_role = parent.client_portal_role
        const enterprise_admin_check = parent.enterprise_admin_check

        if (!!ownFieldValue || !!enterprise_admin_check || !!client_portal_role?.id) {
          return true
        } else {
          return createError({
            path,
            message: roleErrorMsg,
          })
        }
      })
      .nullable(),
    client_portal_role: yup.object()
      .test('candidate_portal_role_required', (ownFieldValue, { createError, path, parent }) => {
        const candidate_portal_role = parent.candidate_portal_role
        const enterprise_admin_check = parent.enterprise_admin_check

        if (!!ownFieldValue || !!enterprise_admin_check || !!candidate_portal_role?.id) {
          return true
        } else {
          return createError({
            path,
            message: roleErrorMsg,
          })
        }
      })
      .nullable(),
    /**way to handle required for yup array */
    country_user_role: yup.array().label('This field')
      .min(1, fetchAdminUserValidationLabel('AdminUserValidationMsg.FieldRequired'))
      .typeError(fetchAdminUserValidationLabel('AdminUserValidationMsg.FieldRequired')),
    service_office_user_role: yup.array().label('This field')
      .min(1, fetchAdminUserValidationLabel('AdminUserValidationMsg.FieldRequired'))
      .typeError(fetchAdminUserValidationLabel('AdminUserValidationMsg.FieldRequired')),

    bio_user_profile: yup.string().label('This field').optional().max(2000),
    expertise: yup.string().label('This field').optional().max(2000),
    linkedIn_id: yup.string().label('This field').optional().max(200),
    twitter_id: yup.string().label('This field').optional().max(200),
    language_user_profile: yup.string().label('This field').optional().max(200),

    time_zone_cronofy: yup.object().label('This field')
      .test('time_zone_cronofy_required', (ownFieldValue, context) => {
        return validateOnCoach(ownFieldValue, context, fetchAdminUserValidationLabel('AdminUserValidationMsg.FieldRequired'))
      })
      .nullable(),
    service_account_name_cronofy: yup.object().label('This field')
      .test('service_account_name_cronofy_required', (ownFieldValue, context) => {
        return validateOnCoach(ownFieldValue, context, fetchAdminUserValidationLabel('AdminUserValidationMsg.FieldRequired'))
      })
      .nullable(),
    available_days: yup.array().label('This field')
      .when(['candidate_portal_role'], {
        is: (candidate_portal_role) => {
          return candidate_portal_role?.selectOptionValue === "e1ae1bfe-ae3c-482b-932b-693c95cd113c" || candidate_portal_role?.selectOptionValue === "4b74544d-6023-4375-b8bb-d6b39f787dce";
        },
        then: yup.array().min(1, fetchAdminUserValidationLabel('AdminUserValidationMsg.FieldRequired')).typeError(fetchAdminUserValidationLabel('AdminUserValidationMsg.FieldRequired')),
        otherwise: yup.array().nullable()
      }),
    working_hours_start_time: yup.object().label('This field')
      .test('working_hours_start_time_required', (ownFieldValue, context) => {
        return validateOnCoach(ownFieldValue, context, fetchAdminUserValidationLabel('AdminUserValidationMsg.FieldRequired'))
      })
      .nullable(),
    working_hours_end_time: yup.object().label('This field')
      .test('end-time-validation', (ownFieldValue, { createError, path, parent }) => {
        const endTime = ownFieldValue;
        const startTime = parent.working_hours_start_time;

        let modifiedStartTime = moment(startTime?.selectOptionValue, "HH:mm");
        let modifiedEndTime = moment(endTime?.selectOptionValue, "HH:mm");

        if (!!modifiedEndTime.isBefore(modifiedStartTime)) {
          return createError({
            path,
            message: fetchAdminUserValidationLabel('AdminUserValidationMsg.ValidationMsgForEndTime'),
          })
        } else if (!!modifiedEndTime.isSame(modifiedStartTime)) {
          return createError({
            path,
            message: fetchAdminUserValidationLabel('AdminUserValidationMsg.ValidationMsgForTime'),
          })
        } else {
          return true
        }
      })
      .test('working_hours_start_time_required', (ownFieldValue, context) => {
        return validateOnCoach(ownFieldValue, context, fetchAdminUserValidationLabel('AdminUserValidationMsg.FieldRequired'))
      }).nullable(),
  });

  return { schema };
};
